import React, { Component } from 'react';
import Headers from '../Layouts/Headers'
import { Gynecology2Sidebar } from '../Layouts/Gynecology2Sidebar'
import axios from 'axios';
import $ from 'jquery';
export class G2DiagnosisStudy extends Component {
    constructor(props) {
        super(props);
    
       
    
        ////
        const url = "";
        this.state = {
            diagnosis:"",
            plan:"",
          DataLoaded: false,
          name: "",
          patientName: localStorage.getItem("currentVisitName"),
          myParentTrigger: "",
        };
    
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
      
      }
    
      componentDidMount() {
        var name = $(".patientName").attr("value");
        console.log(name);
    
       
     
      }
    
      handleChange(event) {
        this.setState({ [event.target.name]: event.target.value });
      }
    
      
    
     
    
      handleSubmit = (event) => {
        const headers = {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
          token: localStorage.getItem("accessToken"),
          visitid: localStorage.getItem("visitId"),
        };
    
        event.preventDefault();
        console.log(this.state);
        axios.post("127.0.0.1:5000/triage/plan/main",
            this.state,
            {
              headers: headers,
            }
          )
          .then((response) => {
            console.log(response);
    
            if (response.data["status"]) {
              $(".alert-success").show();
              setTimeout(function () {
                // window.location.href = "/triage/ob/sound";
    
                // $('.HistoryModal').show()
              }, 1500);
            }
          })
          .catch((error) => {
            console.log(error);
          });
      };


    render() {

        const font16 = { fontSize: '16px' };
        const fontFamilyNunito = { fontFamily: 'Nunito, sans-serif' };
        const floatRight = { float: 'right;' }
        const floatLeft = { float: 'left;' }
        const displayHidden = { display: 'none' }
        const { diagnosis , plan} = this.state;
        return (
            <div>
                <Headers />
                <Gynecology2Sidebar></Gynecology2Sidebar>
                <main className="content-container">

                    <div className="container p-2">
                        <form onSubmit={this.handleSubmit}>



                            <div className="form-row pt-4">
                                <div className="col-md-12 text-lg-left font-weight-bold p-1">
                                    <p className="text-capitalize" style={font16}>Diagnosis</p>
                                </div>

                                <div className="col-md-12 p-2">

                                    <div className="py-1">
                                        <h6 className="text-capitalize" style={fontFamilyNunito}>Report </h6><textarea name="diagnosis" value={diagnosis} className="form-control"></textarea>
                                    </div>


                                </div>


                            </div>
                            <div className="form-row pt-4">
                                <div className="col-md-12 text-lg-left font-weight-bold p-1">
                                    <p className="text-capitalize" style={font16}>Plan</p>
                                </div>

                                <div className="col-md-12 p-2">

                                    <div className="py-1">
                                        <h6 className="text-capitalize" style={fontFamilyNunito}>Report </h6><textarea name="diagnosis" value={diagnosis} className="form-control"></textarea>
                                    </div>


                                </div>


                            </div>

                            <div className="form-row pt-4">
                                <div className="col-md-12 text-lg-left font-weight-bold p-1">
                                    <p className="text-capitalize" style={font16}>Medication</p>
                                </div>

                                <div className="col-md-12 p-2">

                                    <div className="py-1">
                                        <h6 className="text-capitalize" style={fontFamilyNunito}>Report </h6><textarea className="form-control"></textarea>
                                    </div>


                                </div>


                            </div>
                            <div className="form-row pt-4">
                                <div className="col-md-12 text-lg-left font-weight-bold p-1">
                                    <p className="text-capitalize" style={font16}>Continuous Medication</p>
                                </div>

                                <div className="col-md-12 p-2">

                                    <div className="py-1">
                                        <h6 className="text-capitalize" style={fontFamilyNunito}>Report </h6><textarea className="form-control"></textarea>
                                    </div>


                                </div>


                            </div>

                            <div className="row" >
                                {/* <div style={displayHidden} className="col col-6"><button className="btn btn-primary btn-warning rounded-pill px-4 font-weight-bold" type="button" style={floatRight}>Send To Triage</button></div> */}
                                <div className="col col-6"><button className="btn btn-primary btn-warning rounded-pill px-5 font-weight-bold" type="submit" style={floatLeft}>Submit</button></div>
                            </div>
                        </form>
                    </div>
                </main>
            </div>
        )
    }
}


export default G2DiagnosisStudy;
